import tw from "twin.macro";

// 2xl:text-5xl
export const MainHeading = tw.h1`font-serif uppercase font-light text-gray-500 text-2xl md:text-3xl lg:text-4xl xl:text-5xl  text-left leading-tight`

export const SectionHeading = tw.h2`mb-4 font-serif font-light text-secondary-500 text-left text-3xl sm:text-4xl lg:text-5xl md:text-left leading-tight`
export const Subheading = tw.h4`uppercase font-serif text-sm font-medium text-primary-500`
export const HighlightedText = tw.span`text-primary-500`;
